<div [formGroup]="form">
  <div [ngSwitch]="formItem.controlType">

    <div class="form-item-title-wrapper" *ngSwitchCase="'title'" [id]="formItem.key">
      <label class="form-item-title">{{formItem.selectedLabel}}</label>
    </div>

    <div class="form-item-category-wrapper" *ngSwitchCase="'category'">
      <div>
        <label class="form-item-category" [id]="formItem.key">{{formItem.selectedLabel}}</label>
      </div>
    </div>

    <div class="form-item-elt-wrapper" *ngSwitchCase="'int'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
        <div class="control-with-invalid-value" *ngIf="formItem.invalidValue">{{formItem.errorHint}}</div>
        <div>
          <dx-number-box class="control-with-tooltip" [attr.data-control-id]="formItem.key" [width]="600" [step]="0"
            [name]="formItem.key" [value]="formItem.value" [readOnly]="formItem.isReadOnly"
            [disabled]="!formItem.isEnabled" [min]="formItem.minValue" [max]="formItem.maxValue"
            (onValueChanged)='onNumberBoxValueChanged($event)' (onContentReady)='onNumberBoxContentReady($event)'>
          </dx-number-box>

        </div>
        <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>
      </div>
    </div>

    <div class="form-item-elt-wrapper" *ngSwitchCase="'string'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
        <div class="control-with-invalid-value" *ngIf="formItem.invalidValue">{{formItem.errorHint}}</div>
        <div>
          <div class="form-item-string-value control-with-tooltip" [attr.data-control-id]="formItem.key">
            {{formItem.value}}
          </div>
          <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>
        </div>
      </div>
    </div>

    <div class="form-item-elt-wrapper" *ngSwitchCase="'button'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" [width]="formItem.widthHint"
          type="default" [disabled]="!formItem.isEnabled" text="{{formItem.selectedLabel}}" [icon]="formItem.icon"
          (onClick)='onActionButtonClicked($event)'>
        </dx-button>
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
      </div>
      <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>
    </div>

    <div class="form-item-elt-wrapper" *ngSwitchCase="'boollist'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
        <div>
          <div class="form-item-string-value control-with-tooltip" [attr.data-control-id]="formItem.key">
            {{formItem.value}}
          </div>
        </div>
      </div>

      <div *ngFor="let checkbox of formItem.children" class="form-row">
        <div [className]="checkbox.labelClass" [id]="checkbox.key" *ngIf="checkbox.isVisible">
          <dx-check-box class="checkbox-with-tooltip" [attr.data-control-id]="checkbox.key" [value]="checkbox.boolValue"
            [readOnly]="checkbox.isReadOnly" [disabled]="!checkbox.isEnabled"
            (onValueChanged)='onCheckBoxValueChanged($event)'>
          </dx-check-box>
          <div class="checkbox-label">{{checkbox.selectedLabel}}</div>
          <dx-button class="control-with-notooltip" [attr.data-control-id]="checkbox.key"
            *ngIf="checkbox.isTooltipDefined" icon="info" (onClick)="onTooltipClicked($event)">
          </dx-button>
        </div>
      </div>
    </div>

    <div class="form-item-elt-wrapper" *ngSwitchCase="'intlist'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
        <div>
          <div class="form-item-string-value control-with-tooltip" [attr.data-control-id]="formItem.key">
            {{formItem.value}}
          </div>
        </div>
      </div>

      <div *ngFor="let intBox of formItem.children" class="form-row">
        <div [className]="intBox.labelClass" [id]="intBox.key" *ngIf="intBox.isVisible">
          <div class="intbox-label">{{intBox.selectedLabel}}</div>
          <dx-number-box class="intbox-with-tooltip" [attr.data-control-id]="intBox.key" [width]="100" [step]="1"  
          [name]="intBox.key" [value]="intBox.value" [readOnly]="intBox.isReadOnly"
          [disabled]="!intBox.isEnabled" [min]="intBox.minValue" [max]="intBox.maxValue"
          [showSpinButtons]="true"
          (onValueChanged)='onNumberBoxValueChanged($event)' (onContentReady)='onNumberBoxContentReady($event)'>
        </dx-number-box>
        <dx-button class="control-with-notooltip" [attr.data-control-id]="intBox.key"
            *ngIf="intBox.isTooltipDefined" icon="info" (onClick)="onTooltipClicked($event)">
         </dx-button>
        </div>
      </div>
    </div>

    <!-- <div class="form-item-elt-wrapper" class="dx-field field-label-override" *ngSwitchCase="'checkbox'" >
      <div  [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}  
          <dx-check-box class="checkbox-with-tooltip" [attr.data-control-id]="formItem.key"
           [value]="formItem.boolValue"
           [readOnly]="formItem.isReadOnly"
           [disabled]="!formItem.isEnabled"
           (onValueChanged)='onCheckBoxValueChanged($event)'>
          </dx-check-box>
          <dx-button class="control-with-tooltip"
          [attr.data-control-id]="formItem.key"
          *ngIf="formItem.isTooltipDefined"
          icon="info"
          (onClick)="onTooltipClicked($event)">
        </dx-button>
        </div>
        <div class="control-with-invalid-value" *ngIf="formItem.invalidValue">{{formItem.errorHint}}</div>
        <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>
    </div> -->

    <div class="form-item-elt-wrapper" class="dx-field field-label-override" *ngSwitchCase="'checkbox'">
      <div [className]="formItem.labelClass" [id]="formItem.key" *ngIf="formItem.isVisible">
        <dx-check-box class="checkbox-with-tooltip" [attr.data-control-id]="formItem.key" [value]="formItem.boolValue"
          [readOnly]="formItem.isReadOnly" [disabled]="!formItem.isEnabled"
          (onValueChanged)='onCheckBoxValueChanged($event)'>
        </dx-check-box>
        <div class="checkbox-label">{{formItem.selectedLabel}}</div>
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
      </div>
      <div class="control-with-invalid-value" *ngIf="formItem.invalidValue">{{formItem.errorHint}}</div>
      <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>
    </div>

    <div class="form-item-elt-wrapper" *ngSwitchCase="'multilinetextbox'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>
        <div class="control-with-invalid-value" *ngIf="formItem.invalidValue">{{formItem.errorHint}}</div>
        <div>
          <dx-text-area name="{{formItem.key}}" class="text-area-override control-with-tooltip"
            [attr.data-control-id]="formItem.key" [height]="formItem.heightHint" [width]="600"
            [(value)]="formItem.value" placeholder="" [disabled]="!formItem.isEnabled" stylingMode="outlined"
            [readOnly]="formItem.isReadOnly" (onValueChanged)='onTextAreaValueChanged($event)'>
          </dx-text-area>

          <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>

          <div>
            <dx-button class="copy-button" *ngIf="formItem.showCopy" stylingMode="contained" text="Copy" type="default"
              [width]="120" [attr.data-control-id]="formItem.key" [icon]="formItem.icon" (onClick)="onCopyButtonClicked($event)">
            </dx-button>

            <dx-button class="validate-button" *ngIf="formItem.showValidate" stylingMode="contained" text="Validate"
              type="default" [width]="120" (onClick)="onValidateButtonClicked($event)">
            </dx-button>
          </div>

        </div>
      </div>
    </div>

    <!-- <select [id]="formItem.key" *ngSwitchCase="'dropdown'" [formControlName]="formItem.key">
        <option *ngFor="let opt of formItem.options" [value]="opt.key">{{opt.key}}</option>
      </select> -->

    <div class="form-item-elt-wrapper" *ngSwitchCase="'dropdown'">
      <div [id]="formItem.key" [className]="formItem.labelClass" *ngIf="formItem.isVisible">{{formItem.selectedLabel}}
        <dx-button class="control-with-tooltip" [attr.data-control-id]="formItem.key" *ngIf="formItem.isTooltipDefined"
          icon="info" (onClick)="onTooltipClicked($event)">
        </dx-button>

        <div class="control-with-invalid-value" *ngIf="formItem.invalidValue">{{formItem.errorHint}}</div>
        <div class="field-label-override">
          <dx-select-box class="control-with-tooltip" [items]="formItem.optionStrs" [width]="600"
            [value]="formItem.value" placeholder="Select a value..." [readOnly]="formItem.isReadOnly"
            [disabled]="!formItem.isEnabled" [attr.data-control-id]="formItem.key"
            (onValueChanged)='onSelectBoxValueChanged($event)'>
          </dx-select-box>
          <div class="field-comment" *ngIf="isCommentDefined">{{formItem.comment}}</div>
        </div>
      </div>
    </div>
  </div>


  <div class="errorMessage" *ngIf="!isValid">{{formItem.selectedLabel}} is required</div>

  <dx-popup [width]="tooltipDlgWidth" [height]="tooltipDlgHeight" title="{{tooltipHeader}}" [showTitle]="true"
    [dragEnabled]="false" [closeOnOutsideClick]="true" [(visible)]="showTooltip">
    <div class="tooltip-container">
      <div class="tooltip-image" *ngIf="hasTooltipImg">
        <img class="tooltip-img" [src]="tooltipImage" />
      </div>
      <div class="tooltip-text" [innerHTML]="tooltipBody">
      </div>
    </div>

    <br />
    <div *ngIf="hasTooltipLink">
      <a class="tooltip-link" href="{{tooltipLinkURL}}" target="_blank">{{tooltipLinkText}}</a>
    </div>
  </dx-popup>

  <dx-popup title="Confirm Action" [showTitle]="true" 
            width="740" height="240"
            [dragEnabled]="false" [closeOnOutsideClick]="true" [(visible)]="showConfirmActionDlg">
            <div class="action-alert-message">
              {{formItem.alertMessage}}
            </div>

            <div class="alert-button-panel">
              <span>
                <dx-button class="alert-dialog-ok-button" [attr.data-control-id]="formItem.key" width="80"
                     (onClick)="onAlertDialogOKClicked($event)">
                  OK
                </dx-button>

                <dx-button class="alert-dialog-cancel-button" [attr.data-control-id]="formItem.key" width="80" 
                      (onClick)="onAlertDialogCancelClicked($event)">
                  Cancel
                </dx-button>
              </span>
          </div>
  </dx-popup> 

  <dx-popup title="Load Case" [showTitle]="true" 
            width="740" height="300"
            [dragEnabled]="false" [closeOnOutsideClick]="true" [(visible)]="showLoadDialog">
            <div class="action-alert-message" style="white-space: pre; max-height: 115px; overflow: auto;">{{formItem.alertMessage}}</div>

            <div class="alert-button-panel">
              <span>
                <dx-button class="alert-dialog-ok-button" [attr.data-control-id]="formItem.key" width="80"
                     (onClick)="onLoadDialogOKClicked($event)" style="bottom: 15px; position: absolute; left: 50%; margin-left: -40px;">
                  OK
                </dx-button>
              </span>
          </div>
  </dx-popup> 

  <dx-popup title="Save Case" [showTitle]="true" 
            width="740" height="300"
            [dragEnabled]="false" [closeOnOutsideClick]="true" [(visible)]="showSaveDialog">
            <div class="action-alert-message">
              {{formItem.alertMessage}}
            </div>

            <div class="dx-field save-case-field">
              <div class="dx-field-value">
                  <dx-text-box
                    valueChangeEvent="keyup"
                    [(value)]="saveFileName"
                  ></dx-text-box>
              </div>
          </div>

            <div class="alert-button-panel">
              <span>
                <dx-button class="alert-dialog-ok-button" [attr.data-control-id]="formItem.key" width="80"
                     (onClick)="onSaveDialogOKClicked($event)" [disabled]="saveFileName == ''">
                  OK
                </dx-button>

                <dx-button class="alert-dialog-cancel-button" [attr.data-control-id]="formItem.key" width="80" 
                      (onClick)="onSaveDialogCancelClicked($event)">
                  Cancel
                </dx-button>
              </span>
          </div>
          <div class="save-case-footer">Case will be placed in the "downloads" directory.</div>
  </dx-popup> 
</div>